import _isObject from "lodash/isObject";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-act';
export var addTempData = createAction('Add temp data', function (key, val) {
  // allow for key, val or an object to be passed
  if (_isObject(key)) return key;
  return _defineProperty({}, key, val);
});
export var removeTempData = createAction('Remove temp data');